import React, { useEffect, useState } from "react";
import MainLayout from "../../components/Layout/MainLayout";
import InProgressProjects from "../../components/InProgress/InProgressProjects";
import { getProjects } from "../../lib/requests";
import Loading from "../../components/Loading";

export default function ApartamentsInProgressProjects({ history }) {
  const [projects, setProjects] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const pageInfo = {
    pageHeader: "Apartments Projects",
    pageName: "In progress",
    className: "studio-layout-info menu-left-bar",
    type: 1,
    category: 2,
    data: projects,
  };
  function addProject(e) {
    e.preventDefault();
    history.push("/apartment/add-in-progress-project");
  }
  useEffect(() => {
    const token = document.cookie.split("=");
    if (!token[1]) {
      history.push("/log-in");
    }
    setShowLoading(true);
    getProjects(
      (data) => {
        setProjects(data);
        setShowLoading(false);
      },
      1,
      2
    );
  }, []);
  const editData = {
    included: true,
    path: "/apartment/edit-in-progress-project"
  }
  return (
    <div className="residential-in-progress-projects projects">
      <MainLayout pageInfo={pageInfo}>
        <InProgressProjects
          pageInfo={pageInfo}
          addProject={addProject}
          setProjects={setProjects}
          editData={editData}
          history={history}
        />
      </MainLayout>
      {showLoading && <Loading />}
    </div>
  );
}
